import React, { useState } from "react";
import { deleteAccount } from "../../actions/commonActions";
import { useHistory, Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

const About = () => {
  const history = useHistory();
  const [error, setError] = useState("");
  const [modalOpen,setModalOpen]=useState(false)
  const handleClose=()=>{
    setModalOpen(false)
  }
  const handleDelete = () => {
    let userId = localStorage.getItem("driver_id");
    // deleteAccount
    
    let payload = { id: userId };
    deleteAccount(payload, (data) => {
      console.log("data_data", data);
      if (data.statusCode === 200) {
        localStorage.removeItem("driverToken");
        localStorage.removeItem("driver_id");
        localStorage.removeItem("first_name");
        localStorage.removeItem("last_name");
        localStorage.removeItem("ev_charging_site_id");
        history.push(`/`);
      } else {
        setError(data?.message);
        setTimeout(() => {
          setError("");
        }, 3000);
      }
    });
  };
  return (
    <div>
      <div class="text-center" style={{ "margin-top": "40%" }}>
        <img
          src={require("../../images/ico.png")}
          height="100px"
          width="100px"
          class="rounded"
          alt="..."
        />
      </div>

      <div className="text-center mt-4">
        <p>Copyright &#169; 2020.eluTAG. All rights reserved</p>{" "}
        <p>You can find more information at</p>{" "}
        <a
          style={{ color: "#74aabb" }}
          href={process.env.REACT_APP_ELUTAG_WEBSITE}
        >
          www.eluTAG.com
        </a>
        <div className="text-center mt-4">
          {" "}
          <button onClick={()=>setModalOpen(true)} className="btn btn-danger">
            Delete Account
          </button>
        </div>
        {error && (
          <div className="text-center mt-4">
            <p>{error}</p>{" "}
          </div>
        )}
      </div>
      <Modal
      show={modalOpen}
      centered
      backdrop="static"
      size="sm"
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Are u want to Sure?</Modal.Title>
      </Modal.Header>

      <Modal.Body className="overflow-auto">
        <p>This will delete your account on eluTAG permanently. You will not be able to recover, log in using this account anymore. All your data will be removed permanently. If you are sure you really	 want to delete your account press the button below!



</p>
<div style={{display:"flex",justifyContent:"flex-end",gap:"20px"}}><button    onClick={()=>{
  handleDelete();setModalOpen(false);
}}         className="btn btn-success"
>Agree</button>
<button  onClick={handleClose}             className="cancelPlanBtn"
>Disagree</button></div>


      </Modal.Body>
    </Modal>
    </div>
  );
};

export default About;
